/**
 * @generated SignedSource<<b0c2ed94e90ebe80ba80bec08b7798a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueTypePickerPaginatedShared$data = {
  readonly issueTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"IssueTypePickerIssueTypeShared">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly totalCount: number;
  } | null | undefined;
  readonly " $fragmentType": "IssueTypePickerPaginatedShared";
};
export type IssueTypePickerPaginatedShared$key = {
  readonly " $data"?: IssueTypePickerPaginatedShared$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTypePickerPaginatedShared">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "IssueTypePickerPaginatedShared"
};

(node as any).hash = "8f239d052f7531271a3f749f1efc064f";

export default node;
